export type DrawLabelPosition = { x: number; y: number };

/**
 * Prevents Leaflet marker churn and sub-pixel jitter while a drawing label is
 * being repositioned around a touch handle. The threshold is deliberately
 * below a physical pixel: a user-visible position shift is still rendered,
 * while round-trip projection noise is ignored.
 */
export const DRAW_LABEL_POSITION_EPSILON_PX = 0.75;

export function shouldUpdateDrawLabelPosition(
  previous: DrawLabelPosition | null | undefined,
  next: DrawLabelPosition,
  epsilon = DRAW_LABEL_POSITION_EPSILON_PX,
): boolean {
  if (!previous) return true;
  return Math.abs(previous.x - next.x) > epsilon || Math.abs(previous.y - next.y) > epsilon;
}

export function shouldReuseDrawLabelMarker(args: {
  hasMarker: boolean;
  previousText: string | null | undefined;
  nextText: string;
  previousPosition: DrawLabelPosition | null | undefined;
  nextPosition: DrawLabelPosition;
}): boolean {
  if (!args.hasMarker || args.previousText !== args.nextText) return false;
  return !shouldUpdateDrawLabelPosition(args.previousPosition, args.nextPosition);
}

/**
 * Geometry may move every pointer frame, but distance labels remain frozen
 * until the drag has committed. This prevents Leaflet DOM transforms from
 * racing with Geoman's midpoint markers and producing visible flicker.
 */
export function shouldRefreshDrawLabels(isDrawingHandleDragging: boolean): boolean {
  return !isDrawingHandleDragging;
}
